import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { TitleBorderContainer } from "@jti/ui-library";
import { isInStock } from "../../utils/isInStock";
import { getInitialSticks } from "../../utils";
import ProductBundlesSingleStick from "./ProductBundlesSingleStick";
import "./ProductBundles.scss";
const getCount = (sticks) => Object.values(sticks).reduce((prev, current) => prev + current, 0);
const ProductBundlesStickBlock = ({ title, options, stockStatusElements, onChange, showValidation, isLoading, sticksCount, }) => {
    const [currentSticks, setCurrentSticks] = useState({});
    const [count, setCount] = useState(0);
    useEffect(() => {
        const initialSticks = getInitialSticks(options, sticksCount, stockStatusElements);
        setCurrentSticks(initialSticks);
        setCount(getCount(initialSticks));
        const triggerInitialChange = () => {
            const quantities = Object.entries(initialSticks)
                .filter(([, qty]) => qty > 0)
                .map(([selection_id, qty]) => ({ selection_id, qty }));
            const value = quantities.map(({ selection_id }) => selection_id);
            onChange({ quantities, value });
        };
        triggerInitialChange();
    }, []);
    const onChangeStick = (id) => (quantity) => {
        if (quantity >= 0) {
            const newSticks = {
                ...currentSticks,
                [id]: quantity,
            };
            const currentCount = getCount(newSticks);
            if (currentCount <= sticksCount) {
                setCurrentSticks(newSticks);
                setCount(currentCount);
            }
        }
    };
    useEffect(() => {
        if (currentSticks) {
            const quantities = Object.keys(currentSticks)
                .filter((key) => currentSticks[key] > 0)
                .map((id) => ({
                selection_id: id,
                qty: currentSticks[id],
            }));
            onChange({
                quantities,
                value: quantities.map((quantity) => quantity.selection_id),
            });
        }
    }, [currentSticks]);
    return (_jsx(TitleBorderContainer, { className: classNames({ error: showValidation && count < sticksCount }), title: `${title} ${count}/${sticksCount}`, isLoading: isLoading, marginBottom: "16px", testId: "refill-count", children: options.map((option) => {
            // TODO: add types / DESP-44757 removing any will review type problems
            const inStock = isInStock(stockStatusElements[option.id]);
            return (_jsx(ProductBundlesSingleStick, { img: option?.product?.thumbnail?.url, count: currentSticks[option.id] || 0, name: option?.label, onChange: onChangeStick(option.id.toString()), isInStock: inStock, isLoading: isLoading, tooltip: option?.product?.tooltipInfo, isLimitReached: count >= sticksCount }, option?.label));
        }) }));
};
export default ProductBundlesStickBlock;
//# sourceMappingURL=ProductBundlesStickBlock.js.map